<template>
  <form @submit.prevent="addItemToOrder">
    <div class="row">
      <div class="mb-3 col-sm-4">
        <label>Product</label>
        <multiselect v-model="order.product" :options="products.objects" placeholder="Select one" label="productName" track-by="productName" :searchable="true" :internal-search="false"
                     @search-change="asyncFindProduct" @select="productSelected">
          <span slot="noResult">No product found. Change search query.</span></multiselect>
        <p
            v-for="error of v$.order.product.$errors"
            :key="error.$uid"
            class="invalid-feedback"
        >
          {{error.$message}}
        </p>
      </div>
      <div class="mb-3 col-sm-3">
        <label>Warehouse</label>
        <multiselect v-model="order.warehouse" :options="warehouses?.objects" placeholder="Select product first" label="name" track-by="publicId" :searchable="true">
          <span slot="noResult">No warehouse found. Change search query.</span></multiselect>
        <p
            v-for="error of v$.order.warehouse.$errors"
            :key="error.$uid"
            class="invalid-feedback"
        >
          {{error.$message}}
        </p>
      </div>
      <div class="mb-3 col-sm-2">
        <label>Quantity</label>
        <input
            v-model="order.quantity"
            type="number"
            class="form-control"
            :class="{
                        'is-invalid': v$.order.quantity.$error,
                  }"
        />
        <p
            v-for="error of v$.order.quantity.$errors"
            :key="error.$uid"
            class="invalid-feedback"
        >
          {{error.$message}}
        </p>
      </div>
      <div class="mb-3 col-sm-3 form-group align-self-end">
        <b-button variant="primary" size="sm" disabled v-if="ordersLoading">
          <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
          Loading
        </b-button>
        <b-button variant="primary" size="sm" class="text-white" type="submit" v-else>
          Add to order
        </b-button>
      </div>
    </div>
  </form>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import Multiselect from 'vue-multiselect'
import {ALL_PRODUCTS_SIMPLE} from "@/gql";
import { ALL_WAREHOUSES } from "@/gql/stock";
import {mapGetters} from "vuex";
import moment from "moment/moment";

export default {
name: "add-sample-product-component",
  setup () {
    return { v$: useVuelidate() }
  },
  components: {
    Multiselect
  },
  data(){
    return{
      order:{
        product: "",
        shipment: "",
        warehouse: "",
        quantity: ""
      },
      shipments: [],
      products: {
        objects: []
      },
      productSearchKeyword: "",
      shipmentSearchKeyword: "",
    }
  },
  props: {
    orderId: {type: String}
  },
  validations() {
    return{
      order:{
        product: {required},
        warehouse: {required},
        quantity: {required}
      }
    }
  },
  apollo: {
    products: {
      query: ALL_PRODUCTS_SIMPLE,
      variables(){
        return {
          page: 1,
          perPage: 30,
          searchKeyword: this.productSearchKeyword,
          shipmentSearchKeyword: this.shipmentSearchKeyword
        }
      }
    },
    warehouses: {
      query: ALL_WAREHOUSES,
      variables() {
        return {
          page: 0,
          perPage: 30,
          isActive: true,
        }
      }
    },
  },
  computed: {
    ... mapGetters({
      ordersLoading: 'orders/ordersLoading'
    }),
  },
  methods: {
    async addItemToOrder(){
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      const data = {
        sampleOrder: this.orderId,
        itemId: this.order.product.publicId,
        itemCount: parseInt(this.order.quantity),
        warehouseId: this.order.warehouse.publicId,
        shipmentId: this.order.shipment.publicId
      }
      this.$emit('addItemToOrder', data)
      this.v$.$touch();

    },
    asyncFindProduct (query) {
      this.productSearchKeyword = query
    },
    productSelected(value){
      this.shipments = value.shipments
    },
    customLabel ({ orderId, warehouseId, expiryDate }) {
      const date = moment(expiryDate).format('ll')
      if (!warehouseId){
        return `${orderId} – No Warehouse - Expiry: ${date}`
      }else {
        return `${orderId} – ${warehouseId?.name} - Expiry: ${date}`
      }
    }
  }
}
</script>

<style scoped>

</style>
